import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../Component/Sidebar";
import TopBar from "../../Component/TopBar";
import "./index.css";
import { navigateTo } from "../../utils/navigation";
import { Grid, Box } from "@mui/material";
import {
  Card,
  Space,
  Button,
  Tag,
  Modal,
  Form,
  Input,
  Switch,
  message,
} from "antd";
import Table from "../../Component/Table";
import { RxDownload } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getRiskStudent } from "../../redux/api/Risk/RiskStudentSlice";
// import DashboardCounter from "../Dashboard/DashboardCounter";
import dash_user from "../../assets/images/high.png";
import dash_pract from "../../assets/images/mod.png";
import low_risk from "../../assets/images/low.png";
import high_risk from "../../assets/images/high_risk.png";
import active_user from "../../assets/images/active_user.png";
import inactive_user from "../../assets/images/inactive_user.png";
import { getOrganisationData } from "../../redux/api/Organisation";
import moment from "moment";

export default function Index() {
  const dispatch = useDispatch();
  const [totalStudent, setTotal] = useState(0);
  const [activeStudent, setActive] = useState(0);
  const [inactive, setInactive] = useState(0);
  const [high, sethigh] = useState(0);
  const [Moderate, setModerate] = useState(0);
  const [low, setLow] = useState(0);
  const [no, setNo] = useState(0);
  const [list, setList] = useState([]);
  const [col, setCol] = useState([
    {
      title: "Name",
      key: "name",
      render: (_, record) => <span className="table-item">{_.firstName}</span>,
    },
    {
      title: "Email ID",
      key: "email",
      render: (_, record) => <span className="table-item">{_.email}</span>,
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => <>{getTags(_.riskStatus)}</>,
    },
    {
      title: "Time",
      key: "time",
      render: (_, record) => (
        <>{moment(_.createdAt).format("YYYY MMM DD  HH:mm A")}</>
      ),
    },
  ]);
  const getTags = (item) => {
    if (item === "NO_RISK") {
      return <Tag color="green">No Risk</Tag>;
    } else if (item === "LOW_RISK") {
      return <Tag color="yellow">Low Risk</Tag>;
    } else if (item === "MODERATE_RISK") {
      return <Tag color="orange">Moderate Risk</Tag>;
    } else if (item === "HIGH_RISK") {
      return <Tag color="red">High Risk</Tag>;
    }
  };
  const getStudentListsData = () => {
    let token = localStorage.getItem("token");
    dispatch(getRiskStudent("Bearer " + token)).then((res) => {
      if (Array.isArray(res.payload.data.payload.data)) {
        let arr = res.payload.data.payload.data;
        setList(arr);
        let highRisk = arr.filter((item) => item.riskStatus === "HIGH_RISK");
        let modRisk = arr.filter((item) => item.riskStatus === "MODERATE_RISK");
        let lowRisk = arr.filter((item) => item.riskStatus === "LOW_RISK");
        let noRisk = arr.filter((item) => item.riskStatus === "NO_RISK");

        sethigh(highRisk.length);
        setModerate(modRisk.length);
        setLow(lowRisk.length);
        setNo(noRisk.length);
      }
    });
  };
  const downloadList = () => {
    const worksheet = XLSX.utils.json_to_sheet(list);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(data, "table-data.xlsx");
  };

  useEffect(() => {
    getStudentListsData();
  }, []);
  const getOrganisation = () => {
    dispatch(getOrganisationData()).then((res) => {
      if (res.payload.status === "success") {
        let profileUpdate = res.payload.message.payload.profileUpdate;
        let availiblityUpdate =
          res.payload.message.payload.proavailiblityUpdatefileUpdate;
        if (profileUpdate === true) {
          navigateTo("/profile");
        }
        if (availiblityUpdate === true) {
          navigateTo("/set-availability");
        }
      }
    });
  };

  useEffect(() => {
    getOrganisation();
  }, []);
  return (
    <Container fluid className="parent-container">
      <Row>
        <Col md={2}>
          <Sidebar />
        </Col>
        <Col md={10} style={{ marginTop: "120px" }}>
          <Container>
            <Row>
              <Col md={3}>
                {/* <DashboardCounter
                  mainIcon={high_risk}
                  activeIcon={active_user}
                  inactiveIcon={inactive_user}
                  title={"High Risk"}
                  total={high}
                  subTitleOne={""}
                  subTitleTwo={""}
                  link={"#"}
                  showBottom={false}
                /> */}
              </Col>
              <Col md={3}>
                {/* <DashboardCounter
                  mainIcon={dash_pract}
                  activeIcon={active_user}
                  inactiveIcon={inactive_user}
                  title={"Moderate Risk"}
                  total={Moderate}
                  subTitleOne={""}
                  subTitleTwo={""}
                  link={"/"}
                  showBottom={false}
                /> */}
              </Col>
              <Col md={3}>
                {/* <DashboardCounter
                  mainIcon={low_risk}
                  activeIcon={active_user}
                  inactiveIcon={inactive_user}
                  title={"Low Risk"}
                  total={low}
                  subTitleOne={""}
                  subTitleTwo={""}
                  link={"#"}
                  showBottom={false}
                /> */}
              </Col>
              <Col md={3}>
                {/* <DashboardCounter
                  mainIcon={dash_user}
                  activeIcon={active_user}
                  inactiveIcon={inactive_user}
                  title={"No Risk"}
                  total={no}
                  subTitleOne={""}
                  subTitleTwo={""}
                  link={"#"}
                  showBottom={false}
                /> */}
              </Col>
            </Row>
          </Container>
          <Container>
            <Box style={{ marginTop: "8px" }}>
              <Grid
                md={12}
                style={{
                  marginTop: "0px",
                  msOverflowStyle: "none",
                  scrollbarWidth: "0px",
                }}
              >
                <Card
                  title="User Risk List"
                  extra={
                    <Button
                      style={{ background: "#4B61FF", color: "#FFFFFF" }}
                      onClick={() => downloadList()}
                    >
                      Download <RxDownload color="#FFFFFF" />
                    </Button>
                  }
                  style={{
                    marginTop: "30px",
                    msOverflowStyle: "none",

                    height: "70vh",
                  }}
                >
                  <div style={{ height: "100vh" }}>
                    <Table
                      col={col}
                      placeholder={"Search student name/Adm No."}
                      data={list}
                    />
                  </div>
                </Card>
              </Grid>
            </Box>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}
